import script from "./imageGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./imageGrid.vue?vue&type=script&setup=true&lang=js"

import "./imageGrid.vue?vue&type=style&index=0&id=11ecf3ec&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11ecf3ec"]])

export default __exports__